import { Badge } from "@shopify/polaris";
interface tagType {
  tag: string;
}
const EditTag = ({ tag }: tagType) => {
  return <Badge tone={tag ? "new" : undefined}>{tag || "N/A"}</Badge>;
};

export default EditTag;
